import React, { useState } from 'react';
import { Box } from '@mui/material';
import { marketingColors as C } from '../../theme_landing_page';
import type { Faq } from '../data/types';

const FaqAccordion: React.FC<{ faqs: Faq[]; defaultOpen?: number }> = ({ faqs, defaultOpen = 0 }) => {
  const [open, setOpen] = useState(defaultOpen);
  if (!faqs.length) return null;
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {faqs.map((f, i) => (
        <Box key={f.q} sx={{ border: `1px solid ${C.hairline}`, borderRadius: '16px', overflow: 'hidden', background: C.white }}>
          <Box
            component="button"
            type="button"
            onClick={() => setOpen(open === i ? -1 : i)}
            sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', padding: '20px 22px', background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit' }}
          >
            <Box sx={{ fontSize: 16.5, fontWeight: 500, color: C.ink }}>{f.q}</Box>
            <Box sx={{ flex: 'none', fontSize: 22, color: C.accent, transform: open === i ? 'rotate(45deg)' : 'rotate(0deg)', transition: 'transform .2s' }}>+</Box>
          </Box>
          {open === i && <Box sx={{ padding: '0 22px 22px', fontSize: 15.5, lineHeight: 1.65, color: C.body }}>{f.a}</Box>}
        </Box>
      ))}
    </Box>
  );
};

export default FaqAccordion;
